<template>
  <div>
    <div style="height: 100px"></div>
    <div class="service-bg animate__animated animate__backInLeft">
      <img src="../assets/img/serve-bg.jpg" alt />
      <div class="common">
        <div class="service-title">
          <div class="service-title-top">亚太服务</div>
          <div class="service-title-bottom">Service</div>
        </div>
      </div>
    </div>
    <div class="service-menu animate__animated animate__backInLeft">
      <div class="common">
        <div class="service-menu-box">
          <div
            :class="isActive == 0 ? 'active' : ''"
            class="service-menu-item"
            @click="handleSetActive(0)"
          >
            集成系统服务
          </div>
          <div
            :class="isActive == 1 ? 'active' : ''"
            class="service-menu-item"
            @click="handleSetActive(1)"
          >
            运维服务
          </div>
          <div
            :class="isActive == 2 ? 'active' : ''"
            class="service-menu-item"
            @click="handleSetActive(2)"
          >
            电子认证服务
          </div>
        </div>
      </div>
    </div>
    <!-- 集成系统服务 -->
    <div
      class="integration-box animate__animated animate__backInLeft"
      key="integration-box1"
      v-if="isActive == 0"
    >
      <div class="goverment-box">
        <div class="common goverment-box-flex">
          <div class="integration-box-left">
            <img
              src="../assets/img/service-img.png"
              style="width: 728px; height: 345px"
              alt
            />
          </div>
          <div class="integration-box-right">
            <div>
              <div class="integration-box-title">
                <span>政府行业</span>
                <div class="line"></div>
              </div>
              <div class="integration-box-cont">
                利用信息化手段，简化、优化政务工作，使得党政机关在工作中全面应用信息技术进行办公、管
                理和为社会提供公共智慧化服务。
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="study-box">
        <div class="common goverment-box-flex">
          <div class="integration-box-left">
            <div style="margin-top: 50px; width: 600px">
              <div class="integration-box-title-left">
                <span>教育行业</span>
                <div class="line-left"></div>
              </div>
              <div class="integration-box-cont-left">
                通过承载教育教学应用，简化网络建设、管理，避免优质教育资源浪费，促进区域资源共享和优质教学资源合理利用，实现教育行业全方位智慧化服务。
              </div>
            </div>
          </div>
          <div class="integration-box-right">
            <img
              src="../assets/img/study-info.png"
              style="width: 728px; height: 345px"
              alt
            />
          </div>
        </div>
      </div>
      <div class="treatment-box">
        <div class="common goverment-box-flex">
          <div class="integration-box-left">
            <img
              src="../assets/img/doctor.png"
              style="width: 728px; height: 345px"
              alt
            />
          </div>
          <div class="integration-box-right">
            <div>
              <div class="integration-box-title">
                <span>医疗行业</span>
                <div class="line"></div>
              </div>
              <div class="integration-box-cont">
                通过打造区域医疗信息平台，利用物联网、人工智能、5G及大数据等技术，实现患者与医务人员、医疗机构、医疗设备之间的互动，逐步实现
                医疗智慧化服务。
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="enterprise-box">
        <div class="common goverment-box-flex">
          <div class="integration-box-left">
            <div style="margin-top: 50px; width: 600px">
              <div class="integration-box-title-left">
                <span>大型企业</span>
                <div class="line-left"></div>
              </div>
              <div class="integration-box-cont-left">
                注重以人为本的设计理念，强调功能简单易用，帮助企业提高工作效率、规范工作流程，增强企业核心竞争力
                和执行力。
              </div>
            </div>
          </div>
          <div class="integration-box-right">
            <img
              src="../assets/img/enterprise.png"
              style="width: 728px; height: 345px"
              alt
            />
          </div>
        </div>
      </div>
    </div>
    <!-- 运维服务 -->
    <div
      class="integration-box animate__animated animate__backInLeft"
      key="integration-box2"
      v-if="isActive == 1"
    >
      <div class="goverment-box">
        <div class="common goverment-box-flex">
          <div class="integration-box-left">
            <img
              src="../assets/img/computer.png"
              style="width: 728px; height: 345px"
              alt
            />
          </div>
          <div class="integration-box-right">
            <div>
              <div class="integration-box-title">
                <span>网络运维服务</span>
                <div class="line"></div>
              </div>
              <div class="integration-box-cont">
                针对客户的网络系统运行所需要的支撑设备进行专业化的监控、巡检维护及优化，及时发现并解决存在的故障及隐患，以确保客户网络系统安全、稳定及高效运行。
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="study-box">
        <div class="common goverment-box-flex">
          <div class="integration-box-left">
            <div style="margin-top: 50px; width: 600px">
              <div class="integration-box-title-left">
                <span>应用运维服务</span>
                <div class="line-left"></div>
              </div>
              <div class="integration-box-cont-left">
                针对客户指定的应用系统提供业务状态监控、业务数据处理、系统故障处理及优化，以确保客户应用系统安全、稳定及高效运行。
              </div>
            </div>
          </div>
          <div class="integration-box-right">
            <img
              src="../assets/img/phone.png"
              style="width: 728px; height: 345px"
              alt
            />
          </div>
        </div>
      </div>
      <div class="treatment-box">
        <div class="common goverment-box-flex">
          <div class="integration-box-left">
            <img
              src="../assets/img/seo.png"
              style="width: 728px; height: 345px"
              alt
            />
          </div>
          <div class="integration-box-right">
            <div>
              <div class="integration-box-title">
                <span>主机存储运维服务</span>
                <div class="line"></div>
              </div>
              <div class="integration-box-cont">
                通过对客户的主机系统进行专业的监控和巡检及优化，及时发现并解决存在的故障和隐患，确保客户主机系统安全、稳定及高效运行。
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="enterprise-box">
        <div class="common goverment-box-flex">
          <div class="integration-box-left">
            <div style="margin-top: 50px; width: 600px">
              <div class="integration-box-title-left">
                <span>数据中心运维服务</span>
                <div class="line-left"></div>
              </div>
              <div class="integration-box-cont-left">
                整合客户现有资源，针对整个数据中心提供定制化服务，及时发现消除问题隐患，提高客户数据中心可用性和安全性，确保客户数据中心正常运行。
              </div>
            </div>
          </div>
          <div class="integration-box-right">
            <img
              src="../assets/img/chat.png"
              style="width: 728px; height: 345px"
              alt
            />
          </div>
        </div>
      </div>

      <div class="treatment-box">
        <div class="common goverment-box-flex">
          <div class="integration-box-left">
            <img
              src="../assets/img/table.png"
              style="width: 728px; height: 345px"
              alt
            />
          </div>
          <div class="integration-box-right">
            <div>
              <div class="integration-box-title">
                <span>桌面运维服务</span>
                <div class="line"></div>
              </div>
              <div class="integration-box-cont">
                通过产品化的桌面服务运作方式,提供给客户标准的桌面外包服务产品,降低客户IT运营的总体成本。
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 电子认证服务 -->
    <div
      class="integration-box animate__animated animate__backInLeft"
      key="integration-box3"
      v-if="isActive == 2"
    >
      <div class="operation-box">
        <div class="common goverment-box-flex-left">
          <div class="integration-box-left">
            <img
              src="../assets/img/ele.png"
              style="width: 728px; height: 400px; margin-top: 30px"
              alt
            />
          </div>
          <div class="integration-box-right" style="margin-top: 80px">
            <div>
              <div class="integration-box-title">
                <span>电子认证服务</span>
                <div class="line"></div>
              </div>
              <div class="integration-box-cont">
                在确保用户身份真实的情况下，向用户发放电子签名认证证书，为电子政务、电子商务等应用提供网上身份认证、电子签名及电子签章等证书认证
                安全服务。
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isActive: 0,
    };
  },
  methods: {
    handleSetActive(type) {
      this.isActive = type;
    },
    handleToTop() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
  },
  watch: {
    $route: function (to, from) {
      this.isActive = to.query.activeNo;
      this.handleToTop();
    },
  },
  mounted() {
    this.isActive = this.$route.query.activeNo;
    this.handleToTop();
  },
};
</script>

<style scoped>
.service-bg {
  height: 450px;
  width: 100%;
  position: relative;
}
.service-bg img {
  width: 100%;
  height: 100%;
}

.service-title-top {
  font-size: 38px;
  line-height: 58px;
  font-weight: 800;
}
.service-title-bottom {
  color: #707070;
  font-size: 28px;
}
.service-menu {
  height: 120px;
  padding-top: 40px;
}
.service-menu-box {
  display: flex;
  justify-content: space-around;
  align-items: flex-end;
  font-size: 25px;
  line-height: 72px;
  padding: 0 80px;
}
.service-menu-item {
  width: 160px;
}
.service-menu-item.active {
  color: #5694f5;
  font-weight: 600;
  border-bottom: 6px solid #5694f5;
}
.goverment-box {
  width: 100%;
  margin: auto;
  height: 600px;
  padding-top: 180px;
  background-color: #f7f8ff;
}

.goverment-box-flex {
  width: 1500px;
  display: flex;
  justify-content: center;
  padding-left: 80px;
  padding-right: 60px;
}
.goverment-box img {
  width: 620px;
  height: 445px;
}
.integration-box-left img {
  width: 620px;
  height: 445px;
}
.study-box {
  padding-top: 115px;
  width: 100%;
  height: 600px;
}
.treatment-box {
  width: 100%;
  height: 600px;
  padding-top: 110px;
  background-color: #f7f8ff;
}
.enterprise-box {
  width: 100%;
  padding-top: 110px;
  height: 600px;
}

.integration-box-right {
  width: 550px;
}
.integration-box-right img {
  width: 537px;
  height: 306px;
}
.integration-box-title {
  font-size: 30px;
  line-height: 128px;
  font-weight: 800;
  text-align: right;
  position: relative;
}
.integration-box-title-left {
  font-size: 30px;
  line-height: 128px;
  font-weight: 800;
  text-align: left;
  position: relative;
}
.line {
  width: 137px;
  height: 4px;
  background-color: #0a85f8;
  position: absolute;
  right: 0;
}
.line-left {
  width: 137px;
  height: 4px;
  background-color: #0a85f8;
  position: absolute;
  left: 0;
}
.integration-box-cont {
  font-size: 20px;
  font-weight: 800;
  line-height: 50px;
  margin-top: 10px;
  text-align: left;
  margin-left: 100px;
}
.integration-box-cont-left {
  font-size: 20px;
  width: 480px;
  font-weight: 800;
  line-height: 50px;
  margin-top: 10px;
  text-align: left;
}
.operation-box {
  height: 880px;
  padding-top: 220px;
  background-color: #f7f8ff;
}
.operation-box img {
  width: 780px;
  height: 650px;
}
.goverment-box-flex-left {
  width: 1500px;
  display: flex;
  justify-content: center;
}
@media screen and (max-width: 1500px) {
  .service-title {
    height: 190px;
    width: 1000px;
  }
  .service-menu-box {
    width: 900px;
  }
  .service-menu-item {
    width: 240px;
    font-size: 22px;
  }
  .service-menu {
    height: 100px;
    padding-top: 10px;
  }
  .integration-box-left img {
    width: 320px;
    height: 245px;
  }
  .integration-box-right {
    width: 450px;
  }
  .integration-box-right img {
    width: 450px;
    height: 280px;
  }
  .integration-box-cont {
    font-size: 20px;
    width: 350px;
  }
  .goverment-box {
    width: 100%;
    height: 610px !important;
    padding-top: 140px;
    background-color: #f7f8ff;
  }
  .integration-box-cont-left {
    font-size: 20px;
    width: 450px;
  }
  .study-box {
    padding-top: 60px;
    width: 100%;
    height: 610px;
  }
  .integration-box-right {
    padding-top: 30px;
    padding-left: 30px;
  }
  .integration-box-right img {
    width: 320px;
    height: 280px;
    margin-top: 30px;
  }
  .treatment-box {
    width: 100%;
    height: 610px;
    padding-top: 60px;
    background-color: #f7f8ff;
  }
  .integration-box-left img {
    margin-top: 60px;
    width: 320px;
    height: 280px;
  }
  .enterprise-box {
    width: 100%;
    padding-top: 60px;
    height: 580px;
  }
  .operation-box {
    height: 680px;
    padding-top: 50px;
    background-color: #f7f8ff;
  }
}
</style>